import { seatByUser } from "./state";
/** Quick messages and emoji (review 0022 decision 142): three seconds apart, at most three in ten. */
export const REACTION_GAP_MS = 3_000;
export const REACTION_WINDOW_MS = 10_000;
export const REACTIONS_PER_WINDOW = 3;
/** Gifts (decision 153): ten seconds apart, at most two to one player in thirty, ten a match. */
export const GIFT_GAP_MS = 10_000;
export const GIFT_TARGET_WINDOW_MS = 30_000;
export const GIFTS_PER_TARGET_WINDOW = 2;
export const GIFTS_PER_MATCH = 10;
function sentBy(state, userId) {
    state.sent ??= {};
    const found = state.sent[userId] ?? { reactions: [], gifts: [], matchGifts: 0 };
    state.sent[userId] = found;
    return found;
}
/** Only a seated person speaks at the table: not a spectator, not a bot (U2, U3). */
function seatedHuman(state, userId) {
    const held = seatByUser(state, userId);
    return held !== null && !held.seat.bot;
}
/** A reaction from a seated player, shown to the table; over the limit it silently goes nowhere (U1). */
export function react(state, userId, reaction, now) {
    if (!seatedHuman(state, userId))
        return [];
    const sent = sentBy(state, userId);
    sent.reactions = sent.reactions.filter((at) => now - at < REACTION_WINDOW_MS);
    const last = sent.reactions[sent.reactions.length - 1];
    if (last !== undefined && now - last < REACTION_GAP_MS)
        return [];
    if (sent.reactions.length >= REACTIONS_PER_WINDOW)
        return [];
    sent.reactions.push(now);
    return [{ type: "reaction", userId, reaction }];
}
function giftAllowed(sent, to, now) {
    sent.gifts = sent.gifts.filter((g) => now - g.at < GIFT_TARGET_WINDOW_MS);
    const last = sent.gifts[sent.gifts.length - 1];
    if (last !== undefined && now - last.at < GIFT_GAP_MS)
        return false;
    if (sent.matchGifts >= GIFTS_PER_MATCH)
        return false;
    return sent.gifts.filter((g) => g.to === to).length < GIFTS_PER_TARGET_WINDOW;
}
/**
 * A gift onto a seated player's picture, bots and yourself included (U15); it replaces whatever they
 * held and stays until they tap it away (review 0022, owner's brief). Over the limit: nothing (U12).
 */
export function sendGift(state, from, to, gift, now) {
    if (!seatedHuman(state, from) || seatByUser(state, to) === null)
        return [];
    const sent = sentBy(state, from);
    if (!giftAllowed(sent, to, now))
        return [];
    sent.gifts.push({ at: now, to });
    sent.matchGifts += 1;
    state.gifts ??= {};
    state.gifts[to] = { gift, from, at: now };
    return [{ type: "broadcast" }];
}
/** The holder taps their gift away (U17). */
export function clearGift(state, userId) {
    if (state.gifts?.[userId] === undefined)
        return [];
    delete state.gifts[userId];
    return [{ type: "broadcast" }];
}
/** A new match gives everyone their ten gifts back. */
export function resetMatchGifts(state) {
    for (const sent of Object.values(state.sent ?? {}))
        sent.matchGifts = 0;
}
/** Gifts on the players seated now; one who left the seat took nothing with them. */
export function seatedGifts(state) {
    const seated = new Set(state.seats.flatMap((seat) => (seat === null ? [] : [seat.userId])));
    return Object.fromEntries(Object.entries(state.gifts ?? {}).filter(([userId]) => seated.has(userId)));
}
//# sourceMappingURL=social.js.map